/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './CategoriesSidebar.css';
import fetch from '../../core/fetch';
import { Link } from 'react-router';


@withStyles(s)
export default class CategoriesSidebar extends Component{
    

    constructor(props) {
        super(props);

        this.state = {
            categories: [],
        };

    }


    componentDidMount(){
        this.GetCategories();
        
    }

    async GetCategories() {
        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: '{categories{id, slug, name}}',
            }),
            credentials: 'include',
        });
        const { data } = await resp.json();
        if (!data || !data.categories) throw new Error('Erreur sur le chargement des catégories !');

        this.setState({ categories: data.categories })

    }

    
    render(){
        
        return (
            <div className={s.root}>
                <div className={`categories`}>
                    <div className={`content`}>
                        <span className={`titreSectionSidebar`}>Catégories</span>
                        <ul>
                        {this.state.categories.map((item, index) => (
                            <li key={index} className={`categorie`}>
                                <Link to={`/blogue/categorie/${item.slug}`} activeClassName="active">{item.name}</Link>
                            </li>
                        ))}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./components/CategoriesSidebar/CategoriesSidebar.js